<template>
  <div v-if="$route.name === 'normgroups'">
    <b-col style="padding-left: 0px;">
      <h1>{{ $t('privatePage.normgroups_header') }}</h1>
    </b-col>
    <b-col lg="6" style="padding-left: 0px;">
      <div v-if="busyFetching" class="text-center">
        <i class="fa fa-4x fa-spinner fa-pulse"></i>
      </div>
      <EasyDataTable
        v-else
        :headers="fields"
        :items="normGroups"
        :alternating="true"
        :rows-per-page="10000"
        :hide-rows-per-page="true"
      >
        <template #item-buttons="item">
          <b-button
            @click="onEditNormGroup(item)"
            size="sm"
            class="fa fa-edit me-1"
          />
          <b-button
            @click="onDeleteNormGroup(item)"
            variant="danger"
            size="sm"
            class="fa fa-trash"
          />
        </template>
      </EasyDataTable>
      <b-button
        to="normgroups/normgroup"
        class="btn-secondary mt-2"
        :disabled="busyFetching"
      >
        {{$t('privatePage.normgroup_add_new')}}
      </b-button>
    </b-col>
  </div>
  <div v-else>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  computed: {
    fields() {
      return [
        { value: 'name', text: this.$t('privatePage.normgroup') },
        { value: 'buttons', text: ' ', tdClass: 'rightAlignedField' }
      ]
    },
    deleteConfirmationMessage() {
      return this.$t('privatePage.normgroup_confirmation')
    }
  },
  data() {
    return {
      busyFetching: false,
      normGroups: []
    }
  },
  methods: {
    ...mapActions({
      showSuccessMessage: 'showSuccessMessage',
      showErrorMessage: 'showErrorMessage'
    }),
    ...mapActions('normGroupsModule', {
      getNormGroups: 'getNormGroups',
      deleteNormGroup: 'deleteNormGroup'
    }),
    getAllNormGroups() {
      this.busyFetching = true
      this.getNormGroups()
        .then(response => {
          this.normGroups = response
          this.busyFetching = false
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    },
    onEditNormGroup(selectedNormGroup) {
      this.$router.push({
        name: 'normgroup',
        params: { selectedNormGroupId: selectedNormGroup.id }
      })
    },
    onDeleteNormGroup(selectedNormGroup) {
      if (window.confirm(this.deleteConfirmationMessage)) {
        this.deleteNormGroup(selectedNormGroup.id)
          .then(() => {
            this.showSuccessMessage(this.$t('privatePage.normgroup_message'))
            this.getAllNormGroups()
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      }
    }
  },
  watch: {
    $route: 'getAllNormGroups'
  },
  created() {
    this.getAllNormGroups()
  }
}
</script>
